import { useEffect, useState } from "react";
import { Banner, Button, RadioButton, Spinner, TextField } from './admin-ui';
import { q_pixel_products } from "../api";
import { pixelError, pixelResponse } from "../utils/pixelsAdmin";

export function PixelProduct({ product, productId }) {
  const [imageFailed, setImageFailed] = useState(false);
  const id = product?.product_id || productId;
  return <div className="pixels-product">
    <span className="pixels-product-image" aria-hidden="true">
      {product?.image && !imageFailed ? <img src={product.image} alt="" onError={() => setImageFailed(true)} /> : <span>◇</span>}
    </span>
    <span><strong>{product?.title || `Product ID: ${id}`}</strong>{product?.title && <small>Product ID: {id}</small>}</span>
  </div>;
}

export default function PixelProductPicker({ selected, onSelect, revision, disabled }) {
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [result, setResult] = useState({ items: [], total: 0, per_page: 10 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    const timer = setTimeout(async () => {
      try {
        const data = pixelResponse(await q_pixel_products({ q: query.trim(), page, per_page: 10 }));
        if (active) setResult(data);
      } catch (e) { if (active) setError(pixelError(e)); }
      finally { if (active) setLoading(false); }
    }, 250);
    return () => { active = false; clearTimeout(timer); };
  }, [query, page, revision, retry]);

  return <div className="pixels-picker">
    <TextField label="Search synced products" placeholder="Search by name, handle or Product ID" value={query} onChange={(value) => { setQuery(value); setPage(1); }} autoComplete="off" disabled={disabled} clearButton onClearButtonClick={() => { setQuery(""); setPage(1); }} />
    {error ? <Banner tone="critical" action={{ content: "Retry", onAction: () => setRetry((value) => value + 1) }}>{error}</Banner>
      : loading ? <div className="pixels-picker-loading"><Spinner size="small" accessibilityLabel="Loading synced products" /></div>
        : result.items.length ? <>
          <div className="pixels-picker-list">
            {result.items.map((product) => <div className="pixels-picker-row" key={product.product_id}>
              <RadioButton name="pixel-product" id={`pixel-product-${product.product_id}`} label={<PixelProduct product={product} />} checked={selected?.product_id === product.product_id} onChange={() => onSelect(product)} disabled={disabled} />
            </div>)}
          </div>
          <div className="pixels-card-footer">
            <span>{result.total} products</span>
            <div className="pixels-actions"><Button disabled={disabled || page === 1} onClick={() => setPage((value) => value - 1)}>Previous</Button><span>Page {page}</span><Button disabled={disabled || page * result.per_page >= result.total} onClick={() => setPage((value) => value + 1)}>Next</Button></div>
          </div>
        </> : <p className="pixels-empty-compact">{query ? "No products match your search. Try another search or choose Enter Product ID." : "No synced products yet. Sync your products or choose Enter Product ID."}</p>}
    {selected && <p className="pixels-selection">Selected: <strong>{selected.title || selected.product_id}</strong> · {selected.product_id}</p>}
  </div>;
}
